﻿function appendCopyrightText() {
    if ($('#currentyear').data('yearshow')=='True') {
        document.getElementById("currentyear").textContent = new Date().getFullYear();
    }
}
$(document).ready(function () {
  appendCopyrightText();
});
